<script>
    import { fade } from 'svelte/transition';
    import { push } from 'svelte-spa-router';
    import { onMount } from 'svelte';
    import fetchData from '../../api.js';
    import UserStore from '../../stores/user';
    import { _ } from "svelte-i18n";

    import Header from '../../components/Header.svelte'; 
    import TopInfo from '../../components/TopInfo.svelte';  
    import Preloader from '../../components/Preloader.svelte'; 

    export let params = {};   // from router
    let isLoading = false;
    let product = null;

    onMount(async () => {
        if (!$UserStore || !$UserStore.data) {
            push('/login');
            return;
        }

        await loadProduct();
    });

    async function loadProduct() {
        isLoading = true;

        try {
            const res = await fetchData(`/products/${params.id}`, {
                method: 'GET'
            });

            // init qty per variant
            if (res?.data?.variants) {
                res.data.variants = res.data.variants.map(v => ({
                    ...v,
                    qty: 1
                }));
            }

            product = res?.data || null;
        } catch (e) {
            console.error(e);
            product = null;
        }

        isLoading = false;
    }

    async function addToCart(variant) {
        isLoading = true;

        try {
            await fetchData('/cart/add', {
                method: 'POST',
                body: {
                    product_id: product.id,
                    variant_id: variant.id,
                    quantity: variant.qty
                }
            });
        } catch (e) {
            console.error(e);
        }

        isLoading = false;
    }
</script>

<div class="page-container" transition:fade={{ delay: 250, duration: 300 }}>
    <Preloader {isLoading} />
    <Header />

    <div class="page">
        <TopInfo />

        {#if product}
            <div class="product-details border">
                <button class="back" on:click={() => push('/agents/products')}>
                    ← {$_('back')}
                </button>

                <h1>{product.name}</h1>

                <!-- Images -->
                {#if product.images && product.images.length}
                    <div class="images">
                        {#each product.images as img}
                            <img src={img} alt={product.name} />
                        {/each}
                    </div>
                {/if}

                <!-- Description -->
                <div class="section">
                    <h3>{$_('product.description')}</h3>
                    <div class="desc">{@html product.description}</div>
                </div>

                <!-- Meta -->
                <div class="meta">
                    <div><b>SKU:</b> {product.sku}</div>
                    <div><b>Category:</b> {product.category}</div>
                    <div><b>Brand:</b> {product.brand}</div>
                </div>

                <!-- Variants -->
                {#if product.variants && product.variants.length}
                    <div class="section">
                        <h3>{$_('product.variants')}</h3>

                        {#each product.variants as variant}
                            <div class="variant-row">
                                <div class="variant-info">
                                    <div class="variant-name">{variant.name}</div>
                                    <div class="variant-sku">{variant.sku}</div>
                                    <div class="variant-price">{variant.price}</div>
                                </div>

                                <div class="variant-actions">
                                    <input
                                        type="number"
                                        min="1"
                                        bind:value={variant.qty}
                                    />
                                    <button on:click={() => addToCart(variant)}>
                                        {$_('agents.cart.add')}
                                    </button>
                                </div>
                            </div>
                        {/each}
                    </div>
                {/if}
            </div>
        {/if}
    </div>
</div>

<style>
    .product-details {
        padding: 15px;
    }

    .back {
        margin-bottom: 10px;
        cursor: pointer;
        background: none;
        border: none;
        color: #007bff;
    }

    h1 {
        margin-bottom: 10px;
    }

    .images {
        display: flex;
        gap: 10px;
        margin-bottom: 15px;
    }

    .images img {
        width: 120px;
        border: 1px solid #eee;
    }

    .section {
        margin-top: 20px;
    }

    .desc {
        font-size: 14px;
    }

    .meta {
        margin-top: 10px;
        font-size: 13px;
        color: #666;
    }

    .variant-row {
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 10px;
        border: 1px solid #efefef;
        margin-top: 8px;
    }

    .variant-info {
        display: flex;
        flex-direction: column;
    }

    .variant-name {
        font-weight: bold;
    }

    .variant-sku,
    .variant-price {
        font-size: 12px;
        color: #666;
    }

    .variant-actions {
        display: flex;
        gap: 5px;
        align-items: center;
    }

    input[type="number"] {
        width: 60px;
        padding: 4px;
    }

    button {
        padding: 6px 10px;
        border: 1px solid #ddd;
        background: white;
        cursor: pointer;
    }

    button:hover {
        background: #efefef;
    }

    .border {
        border: 1px solid #efefef;
    }
</style>
